module.exports = __webpack_public_path__ + "static/media/magnifying.85c6df64.svg";